import React from 'react';

import { Col, Cols, Row, Rows, Text } from '~/src/dash/publicaUI';
import { useSandboxStore } from '~/src/dash/views/sandbox/contexts';

export const ContextsDemo = () => {
  const { cfg } = useSandboxStore();
  return (
    <Cols responsive rowBreakSize='medium'>
      {cfg.contexts.map((context: Record<string, any>) => (
        <Col flex>
          <Cols>
            <Col width={112}>
              <Text highlighted bold>
                {context.hook}
              </Text>
            </Col>
            <Col>
              <Rows>
                {context.values.map((value: string) => (
                  <Row noVerticalPadding>
                    <Text>{value}</Text>
                  </Row>
                ))}
              </Rows>
            </Col>
          </Cols>
        </Col>
      ))}
    </Cols>
  );
};
